const getInviteFetchingSelector = (state) => state.invite.fetching;
const getInviteSelector = (state) => state.invite.invite;

export { getInviteSelector, getInviteFetchingSelector };
